import {NuxtIcon} from "#components";
import {h} from "vue";
import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "svg-AH-logo_svg__Layer_1",
  "data-name": "Layer 1",
  viewBox: "0 0 229.49 175"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(".svg-AH-logo_svg__cls-2{fill:#fff}", -1)
        ]))]),
        _: 1
      }))
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("path", {
      id: "svg-AH-logo_svg__path83",
      d: "M229.49 87.5c0-48.33-51.37-87.5-114.74-87.5S0 39.17 0 87.5 51.37 175 114.75 175 229.5 135.83 229.5 87.5",
      style: {"fill":"#d71920"}
    }, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("path", {
      id: "svg-AH-logo_svg__path85",
      d: "M60.5 18.47s20.36 9.43 35.04 25.95c0 0 29.72 31.77 35.42 34.67 0 0-11.93 8.35-61.84-39.03 0 0-30.64 24.51-32.11 44.84h186.43l.2 6.36H36.65s1.46 17.79 29.91 44.3c0 0 41.64-36.68 64.58-40.13l1.28-.18s-15.23 12.9-25.33 24.34c0 0-28.25 29.4-48.79 36.48 0 0-75.79-32.32-44.42-98.22 0 0 10.94-22.96 46.62-39.39",
      class: "svg-AH-logo_svg__cls-2"
    }, null, -1)),
    _cache[3] || (_cache[3] = _createElementVNode("path", {
      id: "svg-AH-logo_svg__path87",
      d: "M94.18 6.98C210.29-4.74 223.29 82.14 223.29 82.14s-35.4 7.17-70.08-32.9c0 0-21.33-22.75-27.47-27.43 0 0-10.84-11.18-27.13-13.74l-4.43-1.09",
      class: "svg-AH-logo_svg__cls-2"
    }, null, -1)),
    _cache[4] || (_cache[4] = _createElementVNode("path", {
      id: "svg-AH-logo_svg__path89",
      d: "M94.73 167.46c116.13 11.48 129.11-73.53 129.11-73.53s-35.4-7.01-70.07 32.18c0 0-21.34 22.25-27.47 26.85 0 0-10.83 10.94-27.13 13.44l-4.44 1.06",
      class: "svg-AH-logo_svg__cls-2"
    }, null, -1))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "AH-logo"}) } }